
<div *ngIf="iconReady">
   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMin meet" viewBox="0 0 28 28">
      <use [attr.xlink:href]="iconReference"></use>
   </svg>
</div>
